
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IonSelectCustomEvent, SelectChangeEventDetail } from '@ionic/core';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { SubItem } from 'src/app/models/sub-item.model';

@Component({
  selector: 'app-filter-live-dialog',
  templateUrl: './filter-live.dialog.html',
  styleUrls: ['./filter-live.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    MainDialogComponent,
  ],
})
export class LiveFilterDialogComponent {
  private _modal = inject(ModalController);

  selected = input<SubItem>(null);
  users = input<SubItem[]>(null);
  selectedPremium = input<SubItem>(null);
  premiumPartners = input<SubItem[]>(null);

  onUser(event: IonSelectCustomEvent<SelectChangeEventDetail<SubItem>>) {
    const user = event.detail.value;
    this._modal.dismiss({ user });
  }

  onPremuim(event: IonSelectCustomEvent<SelectChangeEventDetail<SubItem>>) {
    const premiumPartner = event.detail.value;
    this._modal.dismiss({ premiumPartner });
  }

  dismiss() {
    this._modal.dismiss();
  }
}
